import { useMemo } from "react";

import {
  useCancelPolicyStatic,
  useCancelPolicyStep,
} from "../CancelPolicyContext";

export const useCancelPolicyFooter = () => {
  const { pageData } = useCancelPolicyStatic();
  const { isLastStep } = useCancelPolicyStep();
  const footer = pageData?.footer;

  return useMemo(
    () => ({
      primaryLabel:
        (isLastStep ? footer?.submitLabel : footer?.nextLabel) ||
        (isLastStep ? "PROCEED WITH CANCELLATION" : "CONTINUE"),
      previousLabel: footer?.previousLabel || "PREVIOUS",
      submitConfirmationPopup: footer?.submitConfirmationPopup,
    }),
    [footer, isLastStep]
  );
};
